import { render, staticRenderFns } from "./Academia_component.vue?vue&type=template&id=5f2a940d&scoped=true"
import script from "./Academia_component.vue?vue&type=script&lang=js"
export * from "./Academia_component.vue?vue&type=script&lang=js"
import style0 from "./Academia_component.vue?vue&type=style&index=0&id=5f2a940d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a940d",
  null
  
)

export default component.exports